import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { NavigationSidebarProvider } from './contexts/navigationSidebar';
import Layout from './components/layout';
import './index.css';
import { FleetProvider } from './contexts/fleet';
import { VehicleProvider } from './contexts/vehicle';
import { RouteProvider } from './contexts/route';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import { LanguageProvider } from './contexts/language';

const App = () => {
  return (
    <React.StrictMode>
      <BrowserRouter>
        <LanguageProvider>
          <I18nextProvider i18n={i18next}>
            <NavigationSidebarProvider>
              <FleetProvider>
                <VehicleProvider>
                  <RouteProvider>
                    <Layout />
                  </RouteProvider>
                </VehicleProvider>
              </FleetProvider>
            </NavigationSidebarProvider>
          </I18nextProvider>
        </LanguageProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);